import React from "react";
import { social } from '../../../config/clinicConfig';

const SocialFollow: React.FC = () => (
    <div className="mt-3">
        <p className="fw-bold mb-1">Follow Us</p>
        <p className="text-muted small mb-2">For the latest dental care tips!</p>
        <div className="d-flex gap-2 flex-wrap">
            {[
                { href: social.instagram, icon: "instagram", label: "Instagram" },
                { href: social.youtube, icon: "youtube", label: "YouTube" },
                { href: social.facebook, icon: "facebook", label: "Facebook" },
                { href: social.twitter, icon: "twitter-x", label: "X" },
                { href: social.linkedin, icon: "linkedin", label: "LinkedIn" },
            ].map(({ href, icon, label }, i) => (
                <a
                    key={i}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={label}
                >
                    <i className={`bi bi-${icon} social-icon`} aria-hidden="true" />
                </a>
            ))}
        </div>
    </div>
);

export default SocialFollow;
